import { DeleteFilled, UploadOutlined } from '@ant-design/icons';
import { Button, Col, Image, Row, Typography, Result } from 'antd'
import React, { useEffect, useState } from 'react'
import { prMain } from '../../../themeConfig';
import { apiAddReportPhotos } from '../../../utils/api';
import './Create/report.css'

export const AddPhotos = ({ size, idReport, refresh, setRefresh, setOpen }) => {
    const { Text } = Typography
    const [state, setstate] = useState({})
    const [urls, seturls] = useState({})
    const [images, setImages] = useState([])
    const [loadbutton, setLoadButton] = useState(false)
    const [isError, setIsError] = useState(false)

    useEffect(() => {
        let obj = {}
        for (let i = 1; i <= size; i++) {
            obj[`img${i}`] = null
        }
        setstate(obj)
        seturls(obj)
        setLoadButton(false)
    }, [])

    const handleImage = (e) => {

        if (!e) return
        setstate(prev => ({ ...prev, [e.target.name]: e.target.files[0] }))
        seturls(prev => ({ ...prev, [e.target.name]: URL.createObjectURL(e.target.files[0]) }))

    }

    const handleRemoveImage = (name) => {

        if (!name) return

        setstate(prev => ({ ...prev, [name]: null }))
        seturls(prev => ({ ...prev, [name]: null }))
        document.getElementById(name).value = "";
    }


    useEffect(() => {
        setImages(Object.values(state))
    }, [state])

    const handleSave = () => {
        setLoadButton(true)
        apiAddReportPhotos(idReport, images).then((response) => {
            setRefresh(!refresh)
            setOpen(false)
            setLoadButton(false)
        }).catch((e) => {
            console.log(e)
            setIsError(true)
        })
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>

            {
                isError ?
                    (
                        <Result
                            status='error'
                            title='Error en la petición'
                            subTitle={`Ha ocurrido un error al intentar guardar ${images.length > 1 ? 'la imagen.' : 'las imágenes.'} Por favor, intente de nuevo.`}
                            extra={[
                                <Button
                                    key='close'
                                    onClick={() => setOpen(false)}
                                    type='primary'
                                >
                                    Cerrar
                                </Button>
                            ]}
                        />
                    ) : (
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <Text style={{ fontSize: 20, textAlign: 'center', marginBottom: '2vh' }}>Agregar fotos</Text>

                            <Row gutter={[24, 24]} style={{ marginLeft: 0 }}>
                                {
                                    Object.keys(state).map((key) => (
                                        <Col xs={24} sm={24} md={24} lg={12} key={key}>
                                            <label style={{ backgroundColor: prMain }} className='input-container' >
                                                <UploadOutlined style={{ marginRight: 10 }} />
                                                <input
                                                    id={key}
                                                    className='inputSelect'
                                                    type="file"
                                                    accept="image/png, image/jpeg"
                                                    name={key}
                                                    onChange={handleImage}
                                                />
                                                Seleccionar Imagen...
                                            </label>
                                            <div style={{ height: 200, display: 'flex', flexDirection: 'column', justifyContent: 'center', marginTop: 15 }}>
                                                {
                                                    urls[key]
                                                        ? <Image id={key} src={urls[key]} alt={key} height={200} style={{ objectFit: 'cover' }} />
                                                        : <Image
                                                            style={{ objectFit: 'cover' }}
                                                            width={'100%'}
                                                            height={200}
                                                            src="error"
                                                            fallback="data:image/png;base64,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"
                                                        />
                                                }
                                                <Button icon={<DeleteFilled />} disabled={state[key] === null} type='link' onClick={() => handleRemoveImage(key)}>Remover</Button>
                                            </div>
                                        </Col>
                                    ))
                                }
                            </Row>
                            <div style={{ marginTop: '3vh', display: 'flex', justifyContent: 'center' }}>
                                <Button type="primary" onClick={() => handleSave()} loading={loadbutton}>Guardar</Button>
                            </div>
                        </div>)
            }

        </div>
    )
}
